export default {
  '201': {
    errorString: 'ID DE COMERCIO NO VÁLIDO',
    description: 'When the merchant ID is invalid, then this error occurs.',
    niceMessage: 'No pudimos procesar tu pago'
  },
  '202': {
    errorString: 'TIPO DE TRANSACCIÓN NO VÁLIDO',
    description: 'When the transaction type in not valid, then this error occurs.',
    niceMessage: 'No pudimos procesar tu pago, elige otra tarjeta o medio de pago'
  },
  '203': {
    errorString: 'MONTO DE TRANSACCIÓN NO VÁLIDO',
    description: 'When the transaction amount is invalid, then this error occurs.',
    niceMessage: 'No pudimos procesar tu pago, elige otra tarjeta o medio de pago'
  },
  '205': {
    errorString: 'TIPO DE MONEDA NO VÁLIDA',
    description: 'When the transaction currency code is invalid, then this error occurs.',
    niceMessage: 'No pudimos procesar tu pago, elige otra tarjeta o medio de pago'
  },
  '207': {
    errorString: 'ID DE TRANSACCIÓN NO VÁLIDO',
    description: 'When the transaction ticket number is invalid, then this error occurs.',
    niceMessage: 'No pudimos procesar tu pago, elige otra tarjeta o medio de pago'
  },
  '211': {
    errorString: 'SOLICITUD NO VÁLIDA',
    description: 'If the request is not in proper format eg. Unencrypted, Invalid JSON',
    niceMessage: 'No pudimos procesar tu pago, elige otra tarjeta o medio de pago'
  },
  '212': {
    errorString: 'INFORMACIÓN ENCRIPTADA NO VÁLIDA',
    description: 'When the encrypted request is not valid, then this error occurs.',
    niceMessage: 'No pudimos procesar tu pago, elige otra tarjeta o medio de pago'
  },
  '215': {
    errorString: 'EL COMERCIO NO TIENE PERMISO PARA PROCESAR UNA TRANSACCIÓN',
    description: 'When we disable a transaction from the store setup, then this error occurs.',
    niceMessage: 'No pudimos procesar tu pago, elige otra tarjeta o medio de pago'
  },
  '216': {
    errorString: 'TRANSACCIÓN REEMBOLSADA',
    description:
      'When a refund transaction occurs after it is already refunded, then this error occurs.',
    niceMessage: 'No pudimos procesar tu pago, elige otra tarjeta o medio de pago'
  },
  '219': {
    errorString: 'EL MONTO ES CERO',
    description: 'When the amount is zero in request, this error occurs.',
    niceMessage: 'No pudimos procesar tu pago, elige otra tarjeta o medio de pago'
  },
  '220': {
    errorString: 'MONTO DE LA TRANSACCIÓN ES DIFERENTE AL MONTO DE LA VENTA INICIAL',
    description:
      'When the transaction amount in token, charge or init doesn’t match, then this error occurs.',
    niceMessage: 'No pudimos procesar tu pago, elige otra tarjeta o medio de pago'
  },
  '222': {
    errorString: 'TRANSACCIÓN NO ENCONTRADA',
    description:
      'When the transaction ticket number is not found in our database then this error occurs.',
    niceMessage: 'No pudimos procesar tu pago, elige otra tarjeta o medio de pago'
  },
  '223': {
    errorString: 'TRANSACCIÓN NO SOPORTADA',
    description:
      'When the transaction is not supported by either Kushki or processor, then this error occurs',
    niceMessage: 'No pudimos procesar tu pago, elige otra tarjeta o medio de pago'
  },
  '225': {
    errorString: 'TIPO DE TRANSACCIÓN NO VÁLIDO',
    description: 'When the transaction type in not valid, then this error occurs.',
    niceMessage: 'No pudimos procesar tu pago, elige otra tarjeta o medio de pago'
  },
  '226': {
    errorString: 'PROCESADOR CC NO ASIGNADO',
    description:
      'When credit processor is ot assigned to the merchant at the time of store setup, then this error occurs.',
    niceMessage: 'No pudimos procesar tu pago, elige otra tarjeta o medio de pago'
  },
  '228': {
    errorString: 'PROCESADOR INALCANZABLE',
    description: 'When we are unable to connect to the processor, then this error occurs.',
    niceMessage:
      'Tu método de pago no está disponible en este momento, elige otra tarjeta o medio de pago'
  },
  '229': {
    errorString: 'EL COMERCIO NO SOPORTA LA TRANSACCIÓN',
    description: 'When the transaction is not supported by the merchant, then this error occurs.',
    niceMessage: 'No pudimos procesar tu pago, elige otra tarjeta o medio de pago'
  },
  '231': {
    errorString: 'ANULACIÓN DE VENTA NO PERMITIDA',
    description:
      'When a void of a sale transaction is performed after refunding the same sale transaction, then this error occurs.',
    niceMessage: 'No pudimos procesar tu pago, elige otra tarjeta o medio de pago'
  },
  '238': {
    errorString: 'TRANSACCÓN ANULADA',
    description: 'When a void of already voided transaction is performed, then this error occurs.',
    niceMessage: 'No pudimos procesar tu pago, elige otra tarjeta o medio de pago'
  },
  '277': {
    errorString: 'INDICADOR DE IDIOMA NO VÁLIDO',
    description: 'When language indicator is invalid, then this error occurs.',
    niceMessage: 'No pudimos procesar tu pago, elige otra tarjeta o medio de pago'
  },
  '322': {
    errorString: 'TRANSACCIÓN NO PERMITIDA',
    description: 'When atransaction is not allowed by a merchant, then this error occurs.',
    niceMessage: 'No pudimos procesar tu pago, elige otra tarjeta o medio de pago'
  },
  '478': {
    errorString: 'SERVIDOR NO DISPONIBLE',
    description: 'When there is some connectivity issue with the server, then this error occurs.',
    niceMessage: 'No pudimos procesar tu pago'
  },
  '509': {
    errorString: 'EL MONTO INGRESADO ES MAYOR O MENOR A LO PERMITIDO',
    description:
      'When the amount of the transaction is less or greater than the amount allowed, then this error occurs.',
    niceMessage: 'No pudimos procesar tu pago'
  },
  '577': {
    errorString: 'EL TOKEN DE LA TRANSACCIÓN NO ES VÁLIDO',
    description:
      'When the transaction token is invalid or doesn’t exist in database, then this error occurs.',
    niceMessage: 'No pudimos procesar tu pago, elige otra tarjeta o medio de pago'
  },
  '578': {
    errorString: 'EL TOKEN DE LA TRANSACCIÓN HA EXPIRADO',
    description:
      'When the transaction is tried after 30 min of token transaction or when the transaction token is reused for a different transaction, then this error occurs.',
    niceMessage: 'No pudimos procesar tu pago, elige otra tarjeta o medio de pago'
  },
  '579': {
    errorString: 'TRANSACCIÓN RECHAZADA',
    description: 'When we are unable to process the request, then this error occurs.',
    niceMessage: 'No pudimos procesar tu pago, elige otra tarjeta o medio de pago'
  },
  '597': {
    errorString: 'NO HAY RESPUESTA DEL PROCESADOR',
    description: 'When we don’t recive any response from the processor, then this error occurs.',
    niceMessage: 'No pudimos procesar tu pago, elige otra tarjeta o medio de pago'
  },
  '701': {
    errorString: 'EL TOKEN DE LA TRANSACCIÓN ES REQUERIDO',
    description:
      'When the transaction token is not given in the sale transaction, then this error occurs.',
    niceMessage: 'No pudimos procesar tu pago, elige otra tarjeta o medio de pago'
  },
  '702': {
    errorString: 'EL MONTO DE LA TRANSACCIÓN NO ES VÁLIDO',
    description: 'When invalid amount is entered, then this error occurs.',
    niceMessage: 'No pudimos procesar tu pago, elige otra tarjeta o medio de pago'
  },
  '703': {
    errorString: 'EL MONTO DE LA TRANSACCIÓN ES REQUERIDO',
    description: 'When transaction amount is not entered, then this error occurs.',
    niceMessage: 'No pudimos procesar tu pago, elige otra tarjeta o medio de pago'
  },
  '704': {
    errorString: 'EL NÚMERO DE TICKET DE LA TRANSACCIÓN NO ES VÁLIDO',
    description: 'When an invalid ticket number is entered, then this error occurs.',
    niceMessage: 'No pudimos procesar tu pago, elige otra tarjeta o medio de pago'
  },
  '705': {
    errorString: 'EL NÚMERO DE TICKET DE LA TRANSACCIÓN ES REQUERIDO',
    description: 'When the ticket number is not entered, then this error occurs.',
    niceMessage: 'No pudimos procesar tu pago, elige otra tarjeta o medio de pago'
  },
  '706': {
    errorString: 'LA CANTIDAD DE MESES ES REQUERIDA',
    description:
      'When the number of months is not entered in the deferred transaction, then this error occurs.',
    niceMessage: 'No pudimos procesar tu pago en cuotas, elige otra tarjeta o medio de pago'
  },
  '707': {
    errorString: 'LA CANTIDAD DE MESES NO ES VÁLIDA',
    description:
      'When an invalid number of months is entered in the deffered transaction, then this error occurs.',
    niceMessage: 'No pudimos procesar tu pago en cuotas, elige otra tarjeta o medio de pago'
  },
  '710': {
    errorString: 'EL COMERCIO NO HA SIDO ENCONTRADO',
    description: 'When the merchant is not found, then this error occurs.',
    niceMessage: 'No pudimos procesar tu pago, elige otra tarjeta o medio de pago'
  },
  '890': {
    errorString: 'DATOS NO ENCONTRADOS',
    description: 'When there is no data for the cookie, then this error occurs.',
    niceMessage: 'No pudimos procesar tu pago, elige otra tarjeta o medio de pago'
  },
  '1000': {
    errorString: 'EL ID DE LA TARJETA ES REQUERIDA',
    description: 'When card token is not entered, then this error occurs.',
    niceMessage: 'No pudimos procesar tu pago, elige otra tarjeta o medio de pago'
  },
  '1001': {
    errorString: 'EL TOKEN DE LA TARJETA NO ES VÁLIDO',
    description: 'When card token entered is not valid, then this error occurs.',
    niceMessage: 'No pudimos procesar tu pago, elige otra tarjeta o medio de pago'
  },
  '1002': {
    errorString: 'EL NOMBRE DEL CONSUMIDOR ES REQUERIDO',
    description: 'When customer first name is not entered, then this error occurs.',
    niceMessage: 'Ingresa un nombre de tarjetahabiente válido'
  },
  '1003': {
    errorString: 'EL NOMBRE DEL CONSUMIDOR NO ES VÁLIDO',
    description: 'When customer first name entered is not valid, then this error occurs.',
    niceMessage: 'Ingresa un nombre de tarjetahabiente válido'
  },
  '1004': {
    errorString: 'EL APELLIDO DEL CONSUMIDOR ES REQUERIDO',
    description: 'When customer last name is not entered, then this error occurs.',
    niceMessage: 'Ingresa un apellido de tarjetahabiente válido'
  },
  '1005': {
    errorString: 'EL APELLIDO DEL CONSUMIDOR NO ES VÁLIDO',
    description: 'When customer last name entered is not valid, then this error occurs.',
    niceMessage: 'Ingresa un apellido de tarjetahabiente válido'
  },
  '1006': {
    errorString: 'NOMBRE DEL PLAN ES REQUERIDO',
    description: 'When plan name is not entered, then this error occurs.',
    niceMessage: 'No pudimos procesar tu pago, elige otra tarjeta o medio de pago'
  },
  '1007': {
    errorString: 'NOMBRE DEL PLAN NO ES VÁLIDO',
    description: 'When plan name entered is not valid, then this error occurs.',
    niceMessage: 'No pudimos procesar tu pago, elige otra tarjeta o medio de pago'
  },
  '1008': {
    errorString: 'FECHA DE INICIO ES REQUERIDA',
    description: 'When start date is not entered, then this error occurs.',
    niceMessage: 'No pudimos procesar tu pago, elige otra tarjeta o medio de pago'
  },
  '1009': {
    errorString: 'FECHA DE INICIO NO ES VÁLIDA',
    description: 'When start date entered is not valid, then this error occurs.',
    niceMessage: 'No pudimos procesar tu pago, elige otra tarjeta o medio de pago'
  },
  '1014': {
    errorString: 'EL TIPO DE AJUSTE NO ES VÁLIDO',
    description: 'When adjustment type entered is not valid, then this error occurs.',
    niceMessage: 'No pudimos procesar tu pago, elige otra tarjeta o medio de pago'
  },
  '1015': {
    errorString: 'LA FECHA DE AJUSTE NO ES VÁLIDA',
    description: 'When adjustment date entered is not valid, then this error occurs.',
    niceMessage: 'No pudimos procesar tu pago, elige otra tarjeta o medio de pago'
  },
  '1016': {
    errorString: 'EL MONTO DE AJUSTE NO ES VÁLIDO',
    description: 'When adjustment amount entered is not valid, then this error occurs.',
    niceMessage: 'No pudimos procesar tu pago, elige otra tarjeta o medio de pago'
  },
  '1017': {
    errorString: 'LOS PERIODOS DE AJUSTE NO SON VÁLIDOS',
    description: 'When adjustment periods entered is not valid, then this error occurs.',
    niceMessage: 'No pudimos procesar tu pago, elige otra tarjeta o medio de pago'
  },
  '1018': {
    errorString: 'NO ES POSIBLE AGREGAR SUBSCRIPCIÓN',
    description:
      'When some network error occurs while inserting subscription then this error occurs.',
    niceMessage: 'No pudimos procesar tu pago, elige otra tarjeta o medio de pago'
  },
  '1019': {
    errorString: 'TOKEN DE SUBSCRIPCIÓN NO ENCONTRADO',
    description:
      'When the subscription token is not present in the database, then this error occurs.',
    niceMessage: 'No pudimos procesar tu pago, elige otra tarjeta o medio de pago'
  },
  '1020': {
    errorString: 'ERROR EN LA CREACIÓN DE LA SUBSCRIPCIÓN',
    description: 'When some error occurs while creating the subscription, then this error occurs.',
    niceMessage: 'No pudimos procesar tu pago, elige otra tarjeta o medio de pago'
  },
  '1021': {
    errorString: 'EL ID DE SUBSCRIPCIÓN ES REQUERIDO',
    description: 'When subscription id is not entered, then this error occurs.',
    niceMessage: 'No pudimos procesar tu pago, elige otra tarjeta o medio de pago'
  },
  '1022': {
    errorString: 'EL ID DE SUBSCRIPCIÓN NO ES VÁLIDO',
    description: 'When subscription id entered is not valid, then this error occurs.',
    niceMessage: 'No pudimos procesar tu pago, elige otra tarjeta o medio de pago'
  },
  '1023': {
    errorString: 'EL CAMPO “PLANID” NO ES VALIDO',
    description: 'When plan id entered is not valid, then this error occurs.',
    niceMessage: 'No pudimos procesar tu pago, elige otra tarjeta o medio de pago'
  },
  '1024': {
    errorString: 'LA FECHA DE FINALIDAD NO ES VÁLIDA',
    description: 'When end date entered is not valid, then this error occurs.',
    niceMessage: 'No pudimos procesar tu pago, elige otra tarjeta o medio de pago'
  },
  '1025': {
    errorString: 'DIA DEL MES NO ES VÁLIDO',
    description: 'When day of month entered is not valid, then this error occurs.',
    niceMessage: 'No pudimos procesar tu pago, elige otra tarjeta o medio de pago'
  },
  '1026': {
    errorString: 'ERROR AL ELIMINAR LA SUBSCRIPCIÓN',
    description: 'When the cancel subscription failed, then this error occurs.',
    niceMessage: 'No pudimos procesar tu pago, elige otra tarjeta o medio de pago'
  },
  '1027': {
    errorString: 'ID DE SUBSCRIPCIÓN NO ENCONTRADO',
    description: 'When the subscription id is not present in database, then this error occurs.',
    niceMessage: 'No pudimos procesar tu pago, elige otra tarjeta o medio de pago'
  },
  '1028': {
    errorString: 'ERROR AL ACTUALIZAR LA SUBSCRIPCIÓN',
    description: 'When the update subscription failed, then this error occurs.',
    niceMessage: 'No pudimos procesar tu pago, elige otra tarjeta o medio de pago'
  },
  '1029': {
    errorString: 'TOKEN DE SUBSCRIPCIÓN EXPIRADO',
    description: 'When the token is in use, then this error occurs.',
    niceMessage: 'No pudimos procesar tu pago, elige otra tarjeta o medio de pago'
  },
  '1031': {
    errorString: 'LA FECHA DE FIN ES REQUERIDA',
    description: 'When the end date is invalid, then this error occurs.',
    niceMessage: 'No pudimos procesar tu pago, elige otra tarjeta o medio de pago'
  },
  '1032': {
    errorString: 'NO HAY SUSCRIPCIONES PARA ID DE COMERCIO',
    description:
      'When the subscriptions are not there in database for the requested merchant id, then this error occurs.',
    niceMessage: 'No pudimos procesar tu pago, elige otra tarjeta o medio de pago'
  },
  '1033': {
    errorString: 'AJUSTE NO VÁLIDO: MONTO SUBTOTALIVA',
    description:
      'When the SUBTOTAL_IVA amount in adjustment Amount Object us invalid, then this error occurs.',
    niceMessage: 'No pudimos procesar tu pago, elige otra tarjeta o medio de pago'
  },
  '1034': {
    errorString: 'AJUSTE NO VÁLIDO: MONTO IVA',
    description:
      'When the IVA amount in adjustment Amount Object is invalid, then this error occurs.',
    niceMessage: 'No pudimos procesar tu pago, elige otra tarjeta o medio de pago'
  },
  '1035': {
    errorString: 'AJUSTE NO VÁLIDO: MONTO SUBTOTALIVA0',
    description:
      'When the SUBTOTAL_IVA0 amount in adjustemnt Amount Object is invalid, then this error occurs.',
    niceMessage: 'No pudimos procesar tu pago, elige otra tarjeta o medio de pago'
  },
  '1036': {
    errorString: 'AJUSTE NO VÁLIDO: MONTO ICE',
    description:
      'When the ICE amount in adjustment Amount Object is invalid, then this error occurs.',
    niceMessage: 'No pudimos procesar tu pago, elige otra tarjeta o medio de pago'
  },
  '004': {
    errorString: 'INFORMACIÓN DE CUENTA NO VÁLIDA',
    description: 'If any card detail is invalid, then this error occurs.',
    niceMessage: 'No pudimos procesar tu pago, elige otra tarjeta o medio de pago'
  },
  '005': {
    errorString: 'NÚMERO DE CUENTA NO VÁLIDO',
    description: 'If account number (Card Number) is not valid, then this error occurs.',
    niceMessage: 'No pudimos procesar tu pago, elige otra tarjeta o medio de pago'
  },
  '006': {
    errorString: 'TRANSACCIÓN RECHAZADA',
    description:
      'When the transaction is declined from the processor, then this error occurs. Comes with different sets of messages depending on the error.',
    niceMessage: 'No pudimos procesar tu pago, elige otra tarjeta o medio de pago'
  },
  '007': {
    errorString: 'CVC NO VÁLIDO',
    description: 'If the card CVV is not valid, then this error occurs.',
    niceMessage: 'No pudimos procesar tu pago, revisa los datos ingresados'
  },
  '017': {
    errorString: 'TARJETA NO VÁLIDA',
    description: 'When the card number is not valid, then this error occurs.',
    niceMessage: 'No pudimos procesar tu pago, revisa los datos ingresados'
  },
  '018': {
    errorString: 'TARJETA VENCIDA',
    description: 'When a expired card is used, then this error occurs.',
    niceMessage: 'No pudimos procesar tu pago, revisa los datos ingresados'
  },
  '019': {
    errorString: 'FONDOS INSUFICIENTES PARA REMBOLSOS',
    description:
      'When the refund transaction comes with more amount than the charge transaction, then this error occurs.',
    niceMessage: 'No pudimos procesar tu pago, elige otra tarjeta o medio de pago'
  },
  '022': {
    errorString: 'TIPO DE TARJETA NO COMPATIBLE POR MRC',
    description:
      'When the card type is disabled in the store setup and if the transaction comes with that card, then this error occurs.',
    niceMessage: 'No pudimos procesar tu pago, elige otra tarjeta o medio de pago'
  },
  '023': {
    errorString: 'FECHA DE EXPIRACIÓN NO VÁLIDA',
    description: 'When the expiry date is invalid, then this error occurs.',
    niceMessage: 'No pudimos procesar tu pago, revisa los datos ingresados'
  },
  K001: {
    errorString: 'EL CUERPO DE LA PETICIÓN ES INVÁLIDO',
    description: 'Malformed body',
    niceMessage: 'No pudimos procesar tu pago, elige otra tarjeta o medio de pago'
  },
  K002: {
    errorString: 'HA OCURRIDO UN ERROR INESPERADO',
    description: 'An unidentified error has occurred, contact support.',
    niceMessage: 'No pudimos procesar tu pago, elige otra tarjeta o medio de pago'
  },
  K003: {
    errorString: 'TARJETA NO HABILITADA POR EL EMISOR',
    description: 'Disabled BIN for eCommerce',
    niceMessage: 'No pudimos procesar tu pago, elige otra tarjeta o medio de pago'
  },
  K004: {
    errorString: 'ID DE COMERCIO O CREDENCIAL NO VÁLIDO',
    description: 'The merchant login ID is invalid',
    niceMessage: 'No pudimos procesar tu pago, elige otra tarjeta o medio de pago'
  },
  K005: {
    errorString: 'TOKEN EXPIRADO',
    description: 'Token is expired or reused for a different transaction',
    niceMessage: 'No pudimos procesar tu pago, elige otra tarjeta o medio de pago'
  },
  K006: {
    errorString: 'MONTO NO ES IGUAL AL ESPERADO',
    description: 'The entered amount is different to the charged amount.',
    niceMessage: 'No pudimos procesar tu pago, elige otra tarjeta o medio de pago'
  },
  K007: {
    errorString: 'ESTE RECIBO YA FUE PAGADO',
    description: 'Receipt has been paid',
    niceMessage: 'Este pago ya ha sido procesado anteriormente'
  },
  K008: {
    errorString: 'ESTE RECIBO YA FUE CANCELADO',
    description: 'Receipt has been canceled',
    niceMessage: 'Este pago ya ha sido rechazado anteriormente'
  },
  K009: {
    errorString: 'RECIBO EXPIRADO',
    description: 'Receipt expired',
    niceMessage: 'No pudimos procesar tu pago, elige otra tarjeta o medio de pago'
  },
  K010: {
    errorString: 'TICKET NUMBER INVÁLIDO',
    description: 'Ticket number is not entered properly in the request',
    niceMessage: 'No pudimos procesar tu pago, elige otra tarjeta o medio de pago'
  },
  K011: {
    errorString: 'CREDENCIALES INVÁLIDAS',
    description: 'When the credentials are not correct, then this error occurs',
    niceMessage: 'No pudimos procesar tu pago, elige otra tarjeta o medio de pago'
  },
  K012: {
    errorString: 'ACCESO NO AUTORIZADO',
    description: 'Authentication token is out of date or incorrect',
    niceMessage: 'No pudimos procesar tu pago, elige otra tarjeta o medio de pago'
  },
  K013: {
    errorString: 'TRANSACCIÓN TOKENIZADA COMO DIFERIDO',
    description:
      'The token request is set for a deferred transaction, but the deferred information is not included in the charge request.',
    niceMessage: 'No pudimos procesar tu pago, elige otra tarjeta o medio de pago'
  },
  K014: {
    errorString: 'TOKEN INVÁLIDO',
    description: 'The transaction token used is not the correct one',
    niceMessage: 'No pudimos procesar tu pago, elige otra tarjeta o medio de pago'
  },
  K020: {
    errorString: 'TRANSACCIÓN RECHAZADA',
    description: 'When we are unable to process the transaction, then this error occurs',
    niceMessage: 'No pudimos procesar tu pago, elige otra tarjeta o medio de pago'
  },
  K322: {
    errorString: 'TRANSACCIÓN RECHAZADA',
    description:
      'When we are unable to process the transaction because of a security rule, then this error occurs',
    niceMessage: 'No pudimos procesar tu pago, elige otra tarjeta o medio de pago'
  },
  K022: {
    errorString: 'TOKEN DE SUSCRIPCIÓN USADO PREVIAMENTE',
    description: 'The subscription token has been used previously',
    niceMessage:
      'Existe una tarjeta registrada previamente en Kushki con los datos ingresados, por favor intenta eliminar la tarjeta y volver a registrarla. De lo contrario, usa otra tarjeta o comunícate con Kushki.'
  }
}
